export const MAX_LENGTH_ENTITY = {
  UF_USER_EMAIL: 320,
  UF_USER_FIRSTNAME: 50,
  UF_USER_LASTNAME: 50,

  UF_CLIENT_NAME: 45,

  UF_SITE_NAME: 45,
  UF_SITE_ADDRESS: 60,
  UF_SITE_ADDITIONAL_ADDRESS: 60,
  UF_SITE_ZIPCODE: 15,
  UF_SITE_CITY: 50,
  UF_SITE_COUNTRY: 50,

  UF_SECTOR_NAME: 45,

  UF_ABILITY_NAME: 100,

  UF_SKILL_NAME: 100,
  UF_SKILL_RNCP_CODE: 10,

  UF_HOLIDAY_COUNTRY: 2,
  UF_HOLIDAY_REGION: 10,
  UF_HOLIDAY_STATE: 6,

  UF_EQUIPMENT_NAME: 50,
  UF_EQUIPMENT_DESCRIPTION: 200
};